<app-facturi-table-view
  [facturi]="tables$ | async"
  [facturiLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (tableCallback)="getTableCallback($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
></app-facturi-table-view>
